import React, { useState, useEffect } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap"
import { post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"
import Loader from "common/loader"
import { DRIVERS_SEARCH } from "helpers/api_endpoints"
import Select from "react-select"
import EditVehicle from "../Vehicles/EditVehicle"
import { set } from "lodash"
//meta title
document.title = "Drivers"
const DriversList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [id, setId] = useState("")
  const [name, setName] = useState("")
  const [vehicleId, setVehicleId] = useState(null)
  const [email, setEmail] = useState("")
  const [mobile, setMobile] = useState("")
  const [accountStatus, setAccountStatus] = useState("")
  const [driverStatus, setDriverStatus] = useState(false)
  const [cargoEmployee, setCargoEmployee] = useState("")
  const [allocatedCar, setAllocatedCar] = useState("")
  const [accountStatusOptions, setAccountStatusOptions] = useState([
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ])
  const [cargoEmployeeOptions, setCargoEmployeeOptions] = useState([
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ])
  const [currentExpressOrderOptions, setCurrentExpressOrderOptions] = useState([
    { value: "0", label: "All" },
    { value: "1", label: "Free" },
    { value: "2", label: "Busy" },
  ])
  const [loading, setLoading] = useState(true)
  const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false)
  const [drivers, setDrivers] = useState([])
  const [currentExpressOrderId, setCurrentExpressOrderId] = useState([])
  const [filters, setFilters] = useState({})
  const [expressDeliveryActivated, setExpressDeliveryActivated] = useState(0)
  const [expressDeliveryActivatedOptions, setExpressDeliveryActivatedOptions] =
    useState([
      { value: "1", label: "Yes" },
      { value: "2", label: "No" },
      { value: "0", label: "All" },
    ])
  const [walletFilter, setWalletFilter] = useState("all")
  const walletFilterOptions = [
    { value: "all", label: "All" },
    { value: "has_cash", label: "Has Cash" },
    { value: "no_cash", label: "No Cash" },
  ]

  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [successMsg, setsuccessMsg] = useState("")

  useEffect(() => {
    successMessage()
    post(`${DRIVERS_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
      .then(response => {
        const data = response.data
        // Only apply client-side filtering for delivery type and wallet status
        const temp = data.data.filter(el => {
          const deliveryTypeMatch =
            expressDeliveryActivated === 0 ||
            (expressDeliveryActivated === 1 &&
              el.deliveryType[0]?.DriverDeliveryType?.status === 1) ||
            (expressDeliveryActivated === 2 &&
              (!el.deliveryType[0] ||
                el.deliveryType[0]?.DriverDeliveryType?.status !== 1))

          const walletMatch =
            walletFilter === "all" ||
            (walletFilter === "has_cash" &&
              parseFloat(el.walletBalance || 0) > 0) ||
            (walletFilter === "no_cash" &&
              parseFloat(el.walletBalance || 0) <= 0)

          return deliveryTypeMatch && walletMatch
        })
        setDrivers(temp)
        setTotalPages(data.pagination.totalPages)
        setPage(data.pagination.currentPage)
        setLoading(false)
      })
      .catch(error => {
        console.log("error", error)
        if (error.response?.status == 400) {
          navigate("/logout")
        }
      })
  }, [page, filters, expressDeliveryActivated, walletFilter])

  const successMessage = () => {
    if (location.state?.successMessage) {
      setsuccessMsg(location.state.successMsg)
      setTimeout(() => {
        location.state.successMessage = null
        setsuccessMsg("")
      }, 4000)
    }
  }


   const handleNumericInput = (e) => {
    const allowedKeys = [
      "Backspace", "Delete", "Tab", "Escape", "Enter"
    ];

    const isNumber = /^[0-9]$/.test(e.key);
    const isAllowedKey = allowedKeys.includes(e.key);

    if (!isNumber && !isAllowedKey) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    if (value === "" || /^\d+$/.test(value)) {
      handleFilter("id", value);
    }
  };

  const handleFilter = (type, value) => {
    const filtvalues = {...filters}
    if (value === "") {
      delete filtvalues[type]
      setFilters(filtvalues)
      return
    }
     
      switch (type) {
        case "id":
          setId(value)
          filtvalues.id = value
          break
        case "name":
          setName(value)
          filtvalues.name = value
          break
        case "email":
          setEmail(value)
          filtvalues.email = value
          break
        case "mobile":
          setMobile(value)
          filtvalues.mobile = value
          break
        case "accountStatus":
          setAccountStatus(value)
          filtvalues.accountStatus = value
          break
        case "driverStatus":
          console.log(value)
          setDriverStatus(!value)
          filtvalues.driverStatus = value ? 2 : 1
          break
        case "cargoEmployee":
          setCargoEmployee(value)
          filtvalues.cargoEmployee = value
          break
        case "allocatedCar":
          setAllocatedCar(value)
          filtvalues.allocatedCar = value
          break
        case "currentExpressOrder":
          setCurrentExpressOrderId(value)
          filtvalues.currentExpressOrder = value
          break
        case "expressDeliveryActivated":
          setExpressDeliveryActivated(value)
          filtvalues.expressDeliveryActivated = value
          break
        case "walletFilter":
          setWalletFilter(value)
          filtvalues.walletFilter = value
          break
        default:
          break
      }
    
    setFilters(filtvalues)
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  const showVehicle = vehicleId => {
    console.log("vehicleId", vehicleId)
    setVehicleId(vehicleId)
    setIsVehicleModalOpen(true)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div>
            <Modal size="lg" isOpen={isVehicleModalOpen} toggle={() => {}}>
              <ModalHeader>
                <h5>Vehicle details</h5>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => {
                    setIsVehicleModalOpen(false)
                  }}
                >
                  Close
                </button>
              </ModalHeader>
              <ModalBody>
                <EditVehicle
                  vehicleId={vehicleId}
                  onSuccess={() => {
                    setIsVehicleModalOpen(false)
                  }}
                  onCancel={() => setIsVehicleModalOpen(false)}
                />
              </ModalBody>
              <ModalFooter></ModalFooter>
            </Modal>
          </div>
          <Breadcrumbs title="Home" breadcrumbItem="Drivers" />
          <Row>
            <Col xl={12}>
              <Card>
                <br></br>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                <CardTitle>
                  <Link to="/drivers/add">
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create</Trans>
                    </button>
                  </Link>
                </CardTitle>

                <div style={{ margin: "25px" }}>
                  <div className="row">
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>ID</Trans>
                      </Label>
                      <Input
                        name="id"
                        className="form-control"
                        placeholder=""
                        type="number"
                        min="1"
                        onKeyPress={handleNumericInput}
                        onChange={handleChange}
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Name</Trans>
                      </Label>
                      <Input
                        name="name"
                        className="form-control"
                        placeholder=""
                        type="text"
                        onChange={e => handleFilter("name", e.target.value)}
                        onKeyDown={e => handleFilter("name", e.target.value)}
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Email</Trans>
                      </Label>
                      <Input
                        name="email"
                        className="form-control"
                        placeholder=""
                        type="text"
                        onChange={e => handleFilter("email", e.target.value)}
                        onKeyDown={e => handleFilter("email", e.target.value)}
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Mobile</Trans>
                      </Label>
                      <Input
                        name="mobile"
                        className="form-control"
                        placeholder=""
                        type="text"
                        onChange={e => handleFilter("mobile", e.target.value)}
                        onKeyDown={e => handleFilter("mobile", e.target.value)}
                      ></Input>
                    </div>

                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Account Status</Trans>
                      </Label>
                      <Select
                        name="accountStatus"
                        options={accountStatusOptions}
                        className="form-control select2"
                        onChange={e => handleFilter("accountStatus", e.value)}
                      />
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Driver Status</Trans>
                      </Label>
                      <FormGroup switch>
                        <Input
                          type="switch"
                          size="md"
                          checked={driverStatus}
                          onClick={() => {
                            handleFilter("driverStatus", driverStatus)
                          }}
                        />
                      </FormGroup>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Express Delivery Activated</Trans>
                      </Label>
                      <Select
                        name="expressDeliveryActivated"
                        options={expressDeliveryActivatedOptions}
                        className="form-control select2"
                        onChange={e =>
                          handleFilter("expressDeliveryActivated", e.value)
                        }
                      />
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Current Express Order</Trans>
                      </Label>
                      <Select
                        name="currentExpressOrder"
                        options={currentExpressOrderOptions}
                        className="form-control select2"
                        onChange={e =>
                          handleFilter("currentExpressOrder", e.value)
                        }
                      />
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Cargo Employee</Trans>
                      </Label>
                      <Select
                        name="cargoEmployee"
                        options={cargoEmployeeOptions}
                        className="form-control select2"
                        onChange={e => handleFilter("cargoEmployee", e.value)}
                      />
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Allocated Car</Trans>
                      </Label>
                      <Input
                        name="allocatedCar"
                        className="form-control"
                        placeholder=""
                        type="text"
                        onChange={e =>
                          handleFilter("allocatedCar", e.target.value)
                        }
                        onKeyDown={e =>
                          handleFilter("allocatedCar", e.target.value)
                        }
                      ></Input>
                    </div>
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Wallet Balance</Trans>
                      </Label>
                      <Select
                        name="walletFilter"
                        options={walletFilterOptions}
                        className="form-control select2"
                        onChange={e => handleFilter("walletFilter", e.value)}
                        defaultValue={walletFilterOptions[0]}
                        placeholder="Filter by wallet balance"
                      />
                    </div>
                  </div>
                </div>

                <CardBody>
                  <div className="table-responsive">
                    <Table className="table table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>
                            <Trans>ID</Trans>
                          </th>
                          <th>
                            <Trans>Driver Name</Trans>
                          </th>
                          <th>
                            <Trans>Email</Trans>
                          </th>
                          <th>
                            <Trans>Mobile</Trans>
                          </th>
                          <th>
                            <Trans>Wallet Balance</Trans>
                          </th>
                          <th>
                            <Trans>Account Status</Trans>
                          </th>
                          <th>
                            <Trans>Driver Type</Trans>
                          </th>
                          <th>
                            <Trans>Driver Status</Trans>
                          </th>
                          <th>
                            <Trans>Emirates ID</Trans>
                          </th>
                          <th>
                            <Trans>License Number</Trans>
                          </th>
                          <th>
                            <Trans>Current Status</Trans>
                          </th>
                          <th>
                            <Trans>Cargo Employee</Trans>
                          </th>
                          <th>
                            <Trans>Vehicle Allocated</Trans>
                          </th>
                          <th>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <th colSpan={10} className="text-center">
                              <Loader></Loader>
                            </th>
                          </tr>
                        ) : null}
                        {drivers.map((driver, index) => (
                          <tr key={index}>
                            <td>{driver.id}</td>
                            <td>
                              {driver.name}
                              <span className="m-2">
                                {driver.deliveryType[0] ? (
                                  driver.deliveryType[0].id == 1 &&
                                  driver.deliveryType[0].DriverDeliveryType
                                    .status == 1 ? (
                                    <Badge className="bg-success">
                                      <Trans>Express</Trans>
                                    </Badge>
                                  ) : (
                                    <p></p>
                                  )
                                ) : (
                                  ""
                                )}
                              </span>
                            </td>
                            <td>
                              {driver.user ? <p>{driver.user.email}</p> : null}
                            </td>
                            <td>
                              {driver.user ? <p>{driver.user.mobile}</p> : null}
                            </td>
                            <td>
                              <p>
                                {driver.walletBalance
                                  ? driver.walletBalance
                                  : "0"}
                              </p>
                            </td>
                            <td>
                              {driver.user ? (
                                <p>
                                  <Badge
                                    className={
                                      driver.user.status == "1"
                                        ? "bg-success"
                                        : "bg-error"
                                    }
                                  >
                                    <Trans>
                                      {driver.user.status == "1"
                                        ? "verified"
                                        : "unverified"}
                                    </Trans>
                                  </Badge>
                                </p>
                              ) : (
                                <p></p>
                              )}
                            </td>
                            <td>
                              {driver?.driverType
                                ?.map(drv => drv.name)
                                .join(" - ")}
                            </td>
                            <td>
                              {
                                <Badge
                                  className={
                                    driver.status == 0
                                      ? "bg-danger"
                                      : "bg-success"
                                  }
                                >
                                  <Trans>
                                    {driver.status == 0
                                      ? "incomplete"
                                      : "complete"}
                                  </Trans>
                                </Badge>
                              }
                            </td>
                            <td>{driver.emiratesId}</td>
                            <td>{driver.licenseNo}</td>
                            <td>
                              <Badge
                                className={
                                  driver.currentStatus === "Free"
                                    ? "bg-success"
                                    : "bg-danger"
                                }
                              >
                                <Trans>{driver.currentStatus}</Trans>
                              </Badge>
                            </td>
                            {/* <td>{driver.currentExpressOrderId==null?<Badge className="bg-success"><Trans>Free</Trans></Badge>:<Link to={`/orders/edit/${driver.currentExpressOrderId}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> Busy</button></Link>}</td> */}
                            <td>
                              {driver.cargoEmployee == 1 ? (
                                <Badge className="bg-success">
                                  <Trans>Yes</Trans>
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  <Trans>No</Trans>
                                </Badge>
                              )}
                            </td>
                            <td>
                              {driver.vehicle[0] ? (
                                <button
                                  className="btn btn-sm btn-info"
                                  onClick={() => {
                                    showVehicle(driver.vehicle[0].id)
                                  }}
                                >
                                  <i className="dripicons-pencil"></i> &nbsp;
                                  <Trans>{driver.vehicle[0].name}</Trans>
                                </button>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>
                              <Link to={`/drivers/edit/${driver.id}`}>
                                <button className="btn btn-sm btn-info">
                                  <i className="dripicons-pencil"></i> &nbsp;
                                  <Trans>Edit</Trans>
                                </button>
                              </Link>{" "}
                              &nbsp;
                              <Link to={`/drivers/control/${driver.id}`}>
                                <button className="btn btn-sm btn-warning">
                                  <i className="dripicons-control"></i> &nbsp;
                                  <Trans>Control</Trans>{" "}
                                </button>
                              </Link>
                              <Link to={`/drivers/remove/${driver.id}`}>
                                <button className="btn btn-sm btn-danger">
                                  <i className="dripicons-trash"></i> &nbsp;
                                  <Trans>Remove</Trans>{" "}
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <br></br>
                  <div className="text-center">
                    {/* Pagination controls */}
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handlePrevPage}
                      disabled={page === 1}
                    >
                      <Trans>Previous</Trans>
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handleNextPage}
                      disabled={page === totalPages}
                    >
                      <Trans>Next</Trans>
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default DriversList
